// extracted by mini-css-extract-plugin
module.exports = {"reactActivityStyle":"_2VQ3YY3ReJuJt-VCYqQF78"};